//
// ■■■■■■ フォーム処理 ■■■■■■
//

/* === フォーム入力自動修正 ===
  - 全てのinputから先頭と文末の空白、改行を削除
  - .js-delHyphenがついたinputからハイフンを削除
  - textareaは処理無し
*/

window.addEventListener("load", function () {
  const _form = document.querySelectorAll(".formrun");
  _form.forEach((f) => {
    const checkElms = f.querySelectorAll("input");
    checkElms.forEach((elm) => {
      // changeのタイミングで処理
      elm.addEventListener("change", (e) => {
        fixVal(e.target);
      });
    });
  });
  // 入力要素
  function fixVal(e) {
    // 行頭末尾の空白を削除
    e.value = e.value.trim();
    // js-delHyphenのついた要素のハイフンを削除
    if (e.classList.contains("js-delHyphen")) {
      e.value = e.value.replace(/[ｰ|−|―|—|–|‑|‐|ー|-|－|-]/g, "");
    }
  }
});

/* === 確認画面に遷移する際の処理 ===
バリデーションが全てokだった場合のみ
全ての入力要素に .formrun-has-success が付与されていればok
もしくは、
.formrun-has-error がなければok

  お問い合わせフォームのGTM計測用
    - form.runの確認画面機能と連携させられるようclass・ID付け替えを行う
  確認画面での入力を不可にする
    - 入力エリアにreadonlyを付与
    - checkboxのlabelに.is-disabledを付与
*/
jQuery(() => {
  // CVボタン
  const $cvButton = jQuery(".js-btnConfirm");
  // 入力要素
  const $checkElms = jQuery("input, textarea, select");
  // チェックボックスのlabel
  const $formField = jQuery(
    ".form-field-check-radio, .form-field-button-with-checkbox"
  );

  // 「確認する」の時のclass&id
  const confirmClass = "js-btnConfirm";
  // 「送信する」の時のclass&id
  const submitClass = "submit_btn";
  // チェックボックス変更不可時に付与するクラス
  const disabledClass = "is-disabled";
  // 表示を切り替えるボタン
  const $toggleBtns = jQuery(".form__contents input");

  // 確認ボタンを押下し、入力内容にエラーがなければ、
  jQuery("[data-formrun-confirm]").on("submit", () => {
    setTimeout(() => {
      if (!jQuery(".formrun-has-error").length) {
        $cvButton.removeClass(confirmClass);
        $cvButton.addClass(submitClass);
        $formField.addClass(disabledClass);
        $cvButton.attr({ id: submitClass });
        $checkElms.attr("readonly", true);
      }
    }, 10);
  });

  // 戻るボタン押下時
  jQuery("[data-formrun-back-button]").on("click", () => {
    $cvButton.removeClass(submitClass);
    $cvButton.addClass(confirmClass);
    $formField.removeClass(disabledClass);
    $cvButton.attr({ id: confirmClass });
    $checkElms.attr("readonly", false);
  });
});
